import { getArrayApiClient } from 'adapter/out/client/apiClient';
import { ReportInstance } from 'domain/entity/reportInstance';

export type ReadReportInstancesCriteria = {
    templateDashboardId?: string;
};

const readReportInstancesApiClient = getArrayApiClient(
    (criteria: ReadReportInstancesCriteria) =>
        criteria && criteria.templateDashboardId ? `dashboards/reports?templateDashboardId=${criteria.templateDashboardId}` : `dashboards/reports`,
    ReportInstance
);

export default readReportInstancesApiClient;
